/** Shared footer navigation — internal routes + external URLs */
export const FOOTER_EXTERNAL = {
  contact: 'https://discord.gg/5apNDEsqVH',
  blog: 'https://blogs.workloob.com',
  docs: 'https://docs.workloob.com',
};

export const FOOTER_LINK_GROUPS = [
  {
    title: 'Company',
    links: [
      { name: 'Privacy', href: '/privacy', external: false },
      { name: 'Terms of Use', href: '/terms', external: false },
    ],
  },
  {
    title: 'Support',
    links: [
      { name: 'Contact Us', href: FOOTER_EXTERNAL.contact, external: true },
      { name: 'Community Guidelines', href: '/guidelines', external: false },
    ],
  },
  {
    title: 'Resources',
    links: [
      { name: 'Blog', href: FOOTER_EXTERNAL.blog, external: true },
      { name: 'Docs', href: FOOTER_EXTERNAL.docs, external: true },
    ],
  },
];
